import { useQuery } from 'react-query';
import { apiRequest } from '../services/api';
import config from '../config';

const fetchHmoData = async ({ queryKey }) => {
  const [_key, postcode, results] = queryKey;

  if (!postcode) {
    throw new Error('Postcode is required');
  }

  const url = `${config.apiUrl}/property-data/hmo?postcode=${encodeURIComponent(
    postcode
  )}&results=${results}`;

  return apiRequest(url, {});
};

const useHmoData = (postcode, results = 5) => {
  const cleanPostcode = postcode?.trim().toUpperCase().replace(/\s+/g, '');

  return useQuery({
    queryKey: ['hmoData', cleanPostcode, results],
    queryFn: fetchHmoData,
    enabled: !!cleanPostcode,
    staleTime: 24 * 60 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export default useHmoData;
